import React from 'react';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-dropdown/dist/index.module.css';
function SectionList(props) {
  const {
    heading,
    children
  } = props;
  return /*#__PURE__*/React.createElement("li", {
    className: styles['sib-dropdown-option-section-header'],
    role: "list"
  }, heading ? /*#__PURE__*/React.createElement("div", {
    className: styles['sib-dropdown-option-section-header-title']
  }, heading) : null, /*#__PURE__*/React.createElement("ul", {
    className: styles['sib-dropdown-option-section-header-content'],
    id: "sib-dropdown-option-section-header-content-id"
  }, children));
}
SectionList.defaultProps = {
  heading: ''
};
SectionList.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.node.isRequired
};
export default SectionList;